"use client";

import { useTranslations } from "next-intl";

export function TowerLegend() {
  const t = useTranslations();

  return (
    <div className="grid grid-cols-2 sm:flex sm:flex-wrap justify-center gap-x-3 gap-y-2 sm:gap-4 md:gap-6 rounded-xl sm:rounded-2xl border border-primary/40 bg-[var(--bg-legend)] p-3 sm:p-4 md:p-5 shadow-[0_8px_32px_rgba(0,0,0,0.3)] mb-6 sm:mb-8 w-auto mx-2 sm:mx-auto">
      <div className="flex items-center gap-1.5 sm:gap-2.5">
        <div className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 rounded border-2 sm:rounded-md border-emerald-500 bg-emerald-950/80" />
        <span className="text-xs sm:text-sm md:text-base font-medium text-default-500">
          {t("tower.legend.available")}
        </span>
      </div>

      <div className="flex items-center gap-1.5 sm:gap-2.5">
        <div className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 rounded border-2 sm:rounded-md border-blue-500 bg-blue-950/80" />
        <span className="text-xs sm:text-sm md:text-base font-medium text-default-500">
          {t("tower.legend.challenged")}
        </span>
      </div>

      <div className="flex items-center gap-1.5 sm:gap-2.5">
        <div className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 rounded border-2 sm:rounded-md border-amber-500 bg-amber-950/80" />
        <span className="text-xs sm:text-sm md:text-base font-medium text-default-500">
          {t("tower.legend.vacation")}
        </span>
      </div>

      <div className="flex items-center gap-1.5 sm:gap-2.5">
        <div className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 rounded border-2 sm:rounded-md border-red-500 bg-red-950/80" />
        <span className="text-xs sm:text-sm md:text-base font-medium text-default-500">
          {t("tower.legend.injured")}
        </span>
      </div>
    </div>
  );
}
